/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import FieldFormControl from '../FieldFormControl';

const ClientName = ({ field, disabled }) => {
	const { values, setFieldValue, getFieldMeta, getFieldHelpers, getFieldProps } =
		useFormikContext();

	const { setTouched } = getFieldHelpers(field.name);
	const { onBlur: onFieldBlur, ...fieldProps } = getFieldProps(field.name);
	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	const [name, setName] = useState(values[field.name] ?? '');

	useEffect(() => {
		setName(values[field.name] ?? '');
	}, [values[field.name]]);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const { field: fieldConfig } = field;

	const hasError = error || name.length > fieldConfig.max;

	return (
		<FieldFormControl
			{...{
				error: hasError,
				disabled,
				currentValue: name,
				errorMessage,
				field,
			}}
		>
			<TextField
				id={field.name}
				fullWidth
				{...fieldProps}
				value={name}
				onChange={(e) => setName(e.target.value)}
				disabled={disabled}
				error={hasError}
				required
				onBlur={async (e) => {
					setFieldValue(field.name, name.trim());
					setName((prev) => prev.trim());
					setTimeout(() => {
						onBlur(e);
					}, 100);
				}}
			/>
		</FieldFormControl>
	);
};

export default ClientName;
